module.exports = __webpack_public_path__ + "static/uni_plexo-ce28b7f3d7401bf2eceb8f9b60da13ba.png";